import { array, bool, func } from "prop-types"
import { Modal, Select } from "components/ui"
import { Box, StackView } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import ManageCategories from "components/admin/manage_categories"

const EditCategories = ({
  categories,
  selectedCategories,
  onAdd,
  onRemove,
  eventIsArchived,
  onModalChange,
  onModalClose,
  isAdmin
}) => {
  const categorySelectOptions = categories.filter(
    c =>
      !selectedCategories.filter(sc => sc.action !== "remove_category").find(sc => sc.id === c.id)
  )

  return (
    <>
      {isAdmin && (
        <StackView
          axis="horizontal"
          alignment="center"
          distribution="space-between"
          marginBottom={0.5}
          postion="relative"
        >
          <label htmlFor="detail-categories" className="mb-0">
            Categories
          </label>
          <Modal
            triggerText="Manage categories"
            headerText="Categories"
            onConfirmClick={onModalClose}
            confirmButtonText="Done"
            confirmButtonProps={{ theme: "flat", size: "md" }}
          >
            <ManageCategories afterChange={onModalChange} />
          </Modal>
        </StackView>
      )}
      {categories.length > 0 ? (
        <div>
          <div
            className="option__input mb-1"
            style={{
              display: categorySelectOptions.length < 1 ? "none" : null
            }}
          >
            <Select
              id="category-select"
              name="categories"
              onChange={onAdd}
              options={[
                { value: "", label: "Select a category" },
                ...categorySelectOptions.map(c => ({
                  value: c.id,
                  label: c.attributes.name
                }))
              ]}
            />
          </div>
          <div className="option__list">
            {eventIsArchived && (
              <ul className="action-list my-0 unstyled">
                <li className="action-list__item">
                  <div className="c-neutral-500 p-1">Archived</div>
                </li>
              </ul>
            )}
            <ul className="action-list my-0">
              {selectedCategories
                .filter(sc => sc.action !== "remove_category")
                .map(sc => {
                  const category = categories.find(c => c.id === sc.id)
                  return (
                    <li className="d-f jc-sb action-list__item" key={category.id}>
                      <div className="p-1">{category.attributes.name}</div>
                      <button
                        className="action-list-item__remove"
                        onClick={() => onRemove(category.id)}
                        aria-label="Remove this category from this signup"
                      >
                        <span className="p-r t-2p">
                          <Icon symbol="general#x" />
                        </span>
                      </button>
                    </li>
                  )
                })}
            </ul>
          </div>
        </div>
      ) : (
        <Box marginBottom={2} padding={1} className="action-list__item">
          You don&apos;t have any categories yet.
        </Box>
      )}
    </>
  )
}

EditCategories.propTypes = {
  categories: array,
  selectedCategories: array,
  eventIsArchived: bool,
  onAdd: func,
  onRemove: func,
  onModalChange: func,
  onModalClose: func,
  isAdmin: bool
}

export default EditCategories
